import { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { GetFundTransferAtom, SetFundTransferAtom } from "../../store/fundTransferAtom";
import { bankingService } from "../../services/bankingService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";

const TRANSFER_TYPE_NAMES = {
    19: "Transfer To Another Account",
    20: "Receive From Another Account",
};

function FundTransferScroll() {
    const getFundTransferAtom = GetFundTransferAtom();
    const setFundTransferAtom = SetFundTransferAtom();
    const { id } = useParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const url = pathname.split('/');
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

    useEffect(() => {
        if (!getFundTransferAtom?.fund_transfer?.length) {
            bankingService.fundTransferList().then(response => {
                const serverData = response?.data;
                setFundTransferAtom({
                    fund_transfer: serverData?.fund_transfer?.length ? serverData.fund_transfer : [],
                    trans_rec_chart_of_accounts: serverData?.trans_rec_chart_of_accounts?.length ? serverData.trans_rec_chart_of_accounts : [],
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const viewDetails = (item) => {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${item.account_ref_no}`);
    };

    const list = getFundTransferAtom?.fund_transfer || [];

    return (
        <section className="border-[1px] rounded-lg bg-white border-gray-200 flex flex-col overflow-y-scroll h-[300px] lg:h-[700px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100">
            {list.map((item, index) => (
                <div
                    key={item.account_ref_no ?? index}
                    onClick={() => viewDetails(item)}
                    className={twMerge(`p-2 lg:p-1 border-b-[1px] cursor-pointer border-gray-200 ${
                        Number(id) === item?.account_ref_no ? "bg-gray-200" : "hover:bg-gray-100"
                    }`)}
                >
                    <div className="text-sm font-bold text-gray-700">
                        {item?.transfer_from_head} &rarr; {item?.transfer_to_head}
                    </div>
                    <div className="text-xs text-gray-400 font-semibold italic">
                        {formatCustomNumber(item?.amount || 0)}
                    </div>
                    <div className="text-xs text-gray-500">
                        {formatCustomDate(item?.journal_date)} &middot; {TRANSFER_TYPE_NAMES[item?.transaction_type_id] || ''}
                    </div>
                </div>
            ))}
            {list.length === 0 && (
                <div className="flex justify-center items-center h-32 text-gray-500 text-sm">No transfers found</div>
            )}
        </section>
    );
}

export default FundTransferScroll;
